export type DateTransformInput = string | number | Date;

export interface DateTransformOptions {
  format?: string;
  toLocaleDate?: boolean;
  fromTimezone?: string;
  includeTimezone?: boolean;
  timezone?: string;
  addTime?: boolean;
  timezoneSuffix?: string;
}

export interface TimeTransformOptions extends Pick<DateTransformOptions, 'toLocaleDate' | 'fromTimezone'> {
  addTimezoneSuffix?: boolean;
}

export enum CalendarType {
  GREGORIAN = 'gregorian',
  BUDDHIST = 'buddhist',
  // IE11 uses different name for buddhist calendar
  THAI = 'thai'
}

/**
 * Type taken from https://raw.githubusercontent.com/angular/angular/8.2.x/packages/common/src/i18n/format_date.ts
 * and altered.
 *
 * Difference to DatePipe: Removed locale and offset parameters.
 */
export type DateFormatter = (date: Date) => string;

/* eslint-disable @typescript-eslint/naming-convention */
// Enum taken from: https://raw.githubusercontent.com/angular/angular/8.2.x/packages/common/src/i18n/format_date.ts
export enum DateType {
  FullYear,
  Month,
  Date,
  Hours,
  Minutes,
  Seconds,
  FractionalSeconds,
  Day
}
/* eslint-enable @typescript-eslint/naming-convention */
